import {
  CALENDAR_EVENT_ADD_REQUEST,
  CALENDAR_EVENT_ADD_SUCCESS,
  CALENDAR_EVENT_ADD_FAILURE,
  CALENDAR_EVENT_EDIT_REQUEST,
  CALENDAR_EVENT_EDIT_SUCCESS,
  CALENDAR_EVENT_EDIT_FAILURE,
  CALENDAR_EVENT_MULTIPLE_ADD_REQUEST,
  CALENDAR_EVENT_MULTIPLE_ADD_SUCCESS,
  CALENDAR_EVENT_MULTIPLE_ADD_FAILURE,
  RESET_CALENDAR_STATE,
  SET_EDITING_EVENT_ID,
  SET_CALENDAR_VIEW_EMPLOYER,
  CALENDAR_SET_SELECTED_CASES,
  CALENDAR_FETCH_REQUEST,
  CALENDAR_FETCH_SUCCESS,
  CALENDAR_FETCH_FAILURE,
} from '../../actions/actionTypes';

const INITIAL_STATE = {
  errorMessage: '',
  status: 'no',
  editingEventId: null,
  editingEventCaseId: null,
  calendarViewEmployer: null,
  selectedCases: null,
  fetchStatus: 'no',
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case CALENDAR_FETCH_REQUEST:
      return { ...state, fetchStatus: 'requesting' };
    case CALENDAR_FETCH_SUCCESS:
      return { ...state, fetchStatus: 'success' };
    case CALENDAR_FETCH_FAILURE:
      return { ...state, fetchStatus: 'failed' };

    case SET_CALENDAR_VIEW_EMPLOYER:
      return { ...state, calendarViewEmployer: !!action.payload };
    case SET_EDITING_EVENT_ID:
      const editingEventId = (action.payload && action.payload.eventId) || null;
      const editingEventCaseId = (action.payload && action.payload.caseId) || null;
      return { ...state, editingEventId, editingEventCaseId };
    case CALENDAR_EVENT_ADD_REQUEST:
    case CALENDAR_EVENT_EDIT_REQUEST:
    case CALENDAR_EVENT_MULTIPLE_ADD_REQUEST:
      return { ...state, status: 'requesting', errorMessage: '' };
    case CALENDAR_EVENT_ADD_SUCCESS:
      return {
        ...state,
        status: 'success',
        errorMessage: '',
        // stateDirty: false,
        editingEventId: action.payload.eventId,
        editingEventCaseId: action.payload.caseId,
      };
    case CALENDAR_EVENT_EDIT_SUCCESS:
    case CALENDAR_EVENT_MULTIPLE_ADD_SUCCESS:
      return {
        ...state,
        status: 'success',
        errorMessage: '',
      };
    case CALENDAR_EVENT_ADD_FAILURE:
    case CALENDAR_EVENT_EDIT_FAILURE:
    case CALENDAR_EVENT_MULTIPLE_ADD_FAILURE:
      return { ...state, status: 'failed', errorMessage: action.payload };
    case CALENDAR_SET_SELECTED_CASES:
      return { ...state, selectedCases: action.payload };

    case RESET_CALENDAR_STATE:
      return {
        ...INITIAL_STATE,
        editingEventId: state.editingEventId,
        editingEventCaseId: state.editingEventCaseId,
        calendarViewEmployer: state.calendarViewEmployer,
      };
  }

  return state;
}
